import { useAuthStore } from '../store';

export function useIsLoggedIn() {
  return useAuthStore((state) => state.isLoggedIn);
}
